import Link from "next/link";
import { forwardRef } from "react";
import type { ComponentPropsWithoutRef, ElementRef } from "react";

type NextLinkProps = ComponentPropsWithoutRef<typeof Link>;

export const NextLink = forwardRef<ElementRef<typeof Link>, NextLinkProps>(function NextLink({ href, target = "_self", prefetch = false, ...props }, ref) {
  return <Link ref={ref} href={href || "/"} target={target} prefetch={prefetch} {...props} />;
});
